var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61",
    "data-name": "Group 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.875,
    height: 195.842,
    viewBox: "0 0 206.875 195.842",
    fill: "#FFE733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 206.875,
    height: 195.841,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M251.091,134.988a4.206,4.206,0,0,0-2.822-1.8c-5.9,0-56.7-2.052-56.7-61.057a3.335,3.335,0,0,0-6.67,0c0,59-50.8,61.057-56.439,61.057a2.913,2.913,0,0,0-2.052.77c-.513.257-.77.77-1.026,1.026a3.805,3.805,0,0,0,0,3.335,3.559,3.559,0,0,0,3.079,1.8h.257c5.9,0,56.439,2.052,56.439,61.057a3.335,3.335,0,1,0,6.67,0c0-58.748,50.539-61.057,56.439-61.057a3.912,3.912,0,0,0,3.079-1.8,3.155,3.155,0,0,0-.257-3.335m-62.853,41.047c-7.44-24.372-25.654-34.89-40.021-39.508,14.366-4.618,32.581-15.136,40.021-39.508,7.44,24.372,25.654,34.89,40.021,39.508-14.366,4.618-32.581,15.136-40.021,39.508",
    transform: "translate(-44.83 -24.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M117.575,43.612a3.457,3.457,0,0,0,3.335-3.592,3.4,3.4,0,0,0-3.335-3.335c-3.079,0-30.785-1.026-30.785-33.351a3.335,3.335,0,0,0-6.67,0c0,32.324-27.707,33.351-30.785,33.351h-.257A3.348,3.348,0,0,0,46,40.021a3.4,3.4,0,0,0,3.335,3.335c3.335,0,30.785,1.026,30.785,33.351a3.4,3.4,0,0,0,3.335,3.335c1.539.257,3.079-1.283,3.079-3.079,0-32.324,27.707-33.351,30.785-33.351ZM83.2,58.235c-4.1-9.749-11.544-15.136-18.471-18.215A34.515,34.515,0,0,0,83.2,21.806c4.1,9.749,11.544,15.136,18.471,18.215A34.515,34.515,0,0,0,83.2,58.235",
    transform: "translate(-16.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M71.575,217.086c-3.079,0-30.785-1.026-30.785-33.351a3.335,3.335,0,1,0-6.67,0c0,32.324-27.707,33.351-30.785,33.351H3.079A3.348,3.348,0,0,0,0,220.421a3.4,3.4,0,0,0,3.335,3.335c3.335,0,30.785,1.026,30.785,33.351a3.4,3.4,0,0,0,3.335,3.335c1.539.513,3.079-1.026,3.079-3.079,0-32.324,27.707-33.351,30.785-33.351h.257a3.457,3.457,0,0,0,3.335-3.592,3.4,3.4,0,0,0-3.335-3.335M37.2,238.892a35.254,35.254,0,0,0-18.471-18.215A34.515,34.515,0,0,0,37.2,202.463c4.1,9.749,11.544,15.136,18.471,18.215A34.515,34.515,0,0,0,37.2,238.892",
    transform: "translate(0 -64.699)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSparkle);
export default __webpack_public_path__ + "static/media/yellow-sparkle.2bee9b8ccbcfe141a033185b47ed3b31.svg";
export { ForwardRef as ReactComponent };